function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconInsider = function SvgIconInsider(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: props.color,
    d: "M19.5 2.5h-15v9C4.5 15 9.308 16 12 16s7.5-1.583 7.5-4.5v-9zm3 4.5a2 2 0 0 1-2 2h-1V4h1a2 2 0 0 1 2 2v1zm-21-1a2 2 0 0 1 2-2h1v5h-1a2 2 0 0 1-2-2V6zM12 16v2m4.5.5h-9v3h9v-3z"
  }));
};
export default SvgIconInsider;